import { Injectable, inject } from '@angular/core';

import {
  getOrderStatusTranslationKey,
  OrderStatus,
  OrderStatusChangeReason,
} from '@ts/order/shared/util-core';
import { I18nService } from '@ts/shared/i18n/util-core';
import { ShippingMethodCode } from '@ts/shipping/shared/util-core';

@Injectable({
  providedIn: 'root',
})
export class OrderStatusI18nService {
  private i18nService = inject(I18nService);

  // `shippingMethodCode` is null where no order is at hand, e.g. a filter.
  translate$(
    orderStatus: OrderStatus,
    shippingMethodCode: ShippingMethodCode | null,
  ): Promise<string> {
    return this.i18nService.translate$(
      getOrderStatusTranslationKey(orderStatus, shippingMethodCode),
    );
  }

  /**
   * Staff's line for why a status changed, then any note staff added, e.g.
   * "Alasan: Stok habis · Sisa 2 dus rusak" (#11905); for `other` the note is
   * the reason itself (#11663).
   */
  async reasonTranslate$(
    reason: OrderStatusChangeReason,
    note: string,
  ): Promise<string> {
    const isNoteTheReason = reason === 'other' && !!note;
    const reasonText = isNoteTheReason
      ? note
      : await this.reasonLabelTranslate$(reason);
    const line = await this.i18nService.translate$(
      'order.statusChangeReason.line',
      { reason: reasonText },
    );
    return note && !isNoteTheReason ? `${line} · ${note}` : line;
  }

  /** A reason's staff label, e.g. "Stok habis". */
  reasonLabelTranslate$(reason: OrderStatusChangeReason): Promise<string> {
    return this.i18nService.translate$(`order.statusChangeReason.${reason}`);
  }
}
